import { SEO_APK_DOWNLOAD_URL_KEY, SEO_CHANNEL_ORIGIN_KEY } from "@/const/storage-key";
import { Env } from "@/libs/env";

export function getSEOChannel(value?: string | null, params = 'seo_channel'): string | null {
  const channel = value ?? (
    typeof window === 'undefined'
      ? null
      : new URLSearchParams(window.location.search).get(params)
  );

  return channel;
}

export function syncSEOChannelToSessionStorage() {
  if (typeof window === 'undefined') return;

  const channel = getSEOChannel();

  try {
    if (channel) {
      window.sessionStorage.setItem(SEO_CHANNEL_ORIGIN_KEY, channel);
      return;
    }

    window.sessionStorage.removeItem(SEO_CHANNEL_ORIGIN_KEY);
  } catch (error) {
    console.error('Failed to sync seo channel to sessionStorage:', error);
  }
}

export function syncApkSeoDownloadUrlToSessionStorage() {
  if (typeof window === 'undefined') return;

  const channel = getSEOChannel();
  try {
    if (channel) {
      const url = `${Env.NEXT_PUBLIC_APK_DOWNLOAD_HOST}/apk/${Env.NEXT_PUBLIC_APP_NAME}${channel}.apk`;
      window.sessionStorage.setItem(SEO_APK_DOWNLOAD_URL_KEY, url);
    }
  } catch (error) {
    console.error('Failed to sync apk seo channel to sessionStorage:', error);
  }
}

export function getSEOChannelFromSessionStorage(): string | null {
  if (typeof window === 'undefined') return null;

  try {
    const channel = window.sessionStorage.getItem(SEO_CHANNEL_ORIGIN_KEY);
    return channel;
  } catch (error) {
    console.error('Failed to read seo channel from sessionStorage:', error);
    return null;
  }
}

export function getApkSeoDownloadUrlFromSessionStorage(): string | null {
  if (typeof window === 'undefined') return null;

  try {
    const url = window.sessionStorage.getItem(SEO_APK_DOWNLOAD_URL_KEY);
    return url;
  } catch (error) {
    console.error('Failed to read apk seo download url from sessionStorage:', error);
    return null;
  }
}

export function clearSEOChannelFromSessionStorage() {
  if (typeof window === 'undefined') return;

  try {
    window.sessionStorage.removeItem(SEO_CHANNEL_ORIGIN_KEY);
  } catch (error) {
    console.error('Failed to clear seo channel from sessionStorage:', error);
  }
}
